const texts = [

  {  // direct texts
    pagetitle: 'EVO - Interactive Training Guide',
    printmessage: "There is no printable version of this guide.",
    altlang: 'FR',
    modaltitle: "Interactive Training Guide",
    modalsubtitle: "New illustration tool - Life Insurance and Critical Illness Insurance",
    errormsg: "The width of your screen is not wide enough. If you are using a mobile device, please switch to landscape mode."
  },
  {  // title attribute values
    // printDesc: 'Print this document',
    altlangtitle: 'Aller à la version française'
  },
  {  // src attribute values
    modallogo: require('../images/IAGF_couleurs_85_EN.jpg')
  }
];

const demoTexts = [
  {  // Universal Life insurance
    productName: "Universal Life insurance",
    productCode: 'ul-ins',
    slides: [
      {
        title: 'Launching EVO',
        code: 'ul-ins-launching',
        image: require('../images/EN_launch.jpg'),
        infos: [
          {
            buttonPosition: [86, 24.5, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [92.3, 26.7, 7.3, 4.7],
            content: "Click on <i>Launch</i> to access EVO.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Home Page',
        code: 'ul-ins-home',
        image: require('../images/EN_UL_home.jpg'),
        infos: [
          {
            buttonPosition: [6.1, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.9, 29.2, 12.6, 6.5],
            content: "Check the <i>New Features</i> section for the latest updates to the EVO platform; tool enhancements, additional features and new products will be presented in detail in this section.",
            modals: [
              {
                code: 'ul_home_modal1',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_home_modal1.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [23.5, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.4, 36.7, 97.3, 63],
            content: "<i>Create an illustration</i> allows you to access the product family to be illustrated. Once the family has been selected, you can select a basic coverage in the middle of the screen.",
            modals: []
          },
          {
            buttonPosition: [39, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [37.3, 29.2, 8, 6.5],
            content: "<i>My files</i> allows you to consult and make changes to saved illustrations, including those created via the Interface Suite.",
            modals: [
              {
                code: 'ul_home_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_home_modal2.jpg') + '" style="max-width: 90%"></div><br>You can search for an existing sale by entering the name of the file, contractor or insured in the search bar. Note that this feature also applies to ongoing or completed sales.'
              }
            ]
          },
          {
            buttonPosition: [70.9, 18.5, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [62.3, 29.1, 22.1, 6.7],
            content: "Click on <i>Critical illness premium comparison</i> tool to view and compare critical illness insurance policy amounts and premiums on the same screen. It will also be available during the illustration in the critical illness insurance product.",
            modals: [
              {
                code: 'ul_home_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/comparison_modal.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [88.9, 18.5, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [84.4, 29.1, 14.1, 6.7],
            content: "<i>Make an e-change</i> allows you to request a change to an in-force policy: client information, addition of coverage, riders, etc.",
            modals: []
          },
          {
            buttonPosition: [84.6, 36.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [85.5, 30.1, 2.8, 4.6],
            content: "The padlock indicates that a connection is required to access the section.",
            modals: []
          },
          {
            buttonPosition: [-6.6, 77, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.6, 78.1, 23.9, 20],
            content: "Select the group <i>Concepts</i> to illustrate certain eligible products and demonstrate how they can help your clients achieve their financial goals and meet their insurance needs.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'General Interface',
        code: 'ul-ins-general-interface',
        image: require('../images/EN_UL_general-interface.jpg'),
        infos: [
          {
            buttonPosition: ['auto', -1.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [-0.6, -1.2, 101.3, 7.4],
            content: "This menu allows you to: <ul>" +
              "<li><img src='" + require('../images/icon-tool.jpg') + "'> Transfer the file to a third party</li>" +
              "<li><img src='" + require('../images/label-connection_EN.jpg') + "' width='73'> Establish a secure connection</li>" +
              "<li><img src='" + require('../images/icon-save.jpg') + "'> Save the illustration and activate the automatic save function</li>" +
              "<li><img src='" + require('../images/icon-suitcase.jpg') + "'> Requirements – Life Insurance / Critical Illness Insurance</li>" +
              "<li><img src='" + require('../images/icon-home.jpg') + "'> Go back to the product family home page</li>" +
              "<li><img src='" + require('../images/icon-settings.jpg') + "'> Customize your profile and default settings</li>" +
              "<li><img src='" + require('../images/icon-help.jpg') + "'> Get information about the software</li>" + "</ul>",
            modals: []
          },
          {
            buttonPosition: ['auto', 8.6, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 5.8, 43.9, 5.7],
            content: "This section allows you to create a new scenario or duplicate one to illustrate alternatives for your client or family members, up to a maximum of five scenarios. Scenarios can also be reset.",
            modals: []
          },
          {
            buttonPosition: [72.4, 9.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [2, 11.6, 69, 6],
            content: "<b><u>Coverages</u>: </b>allows you to show the type of coverage selected, identify the insureds and applicants, select additional coverages and riders, and simulate a premium based on projected deposits and withdrawals.<br><br>" +
              "<b><u>Investor profile</u>: </b>allows you to fill out the form in order to establish the investor profile.<br><br>" +
              "<b><u>Investments</u>: </b>allows you to indicate the segregated funds in the client’s policy portfolio account.<br><br>" +
              "<b><u>Concepts</u>: </b>allows you to activate and configure a sales concept for the illustration in progress or deactivate it.<br><br>" +
              "<b><u>Results</u>: </b>allows you to consult the projection results grid for the current scenario.<br><br>" +
              "<b><u>Reports</u>: </b>allows you to generate and print the illustration report.",
            modals: []
          },
          {
            buttonPosition: ['auto', 49, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 17.6, 79.1, 82],
            content: "This section allows you to enter the illustration information quickly in order to quickly get a premium.",
            modals: []
          },
          {
            buttonPosition: [72.6, 83, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [79.2, 17.6, 20.5, 82],
            content: "<b><u>Contract</u>: </b>shows the premium paid for your client’s policy as well as the reference and maximum premium.<br><br>" +
              "<b><u>Coverage details</u>: </b>shows all coverages for all insureds in the current scenario.<br><br>" +
              "<b><u>Go to the e-application</u>: </b>if one of the checkmarks is grey, you must add the missing information before you can move on to the application.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Coverages (Insureds and Coverages)',
        code: 'ul-ins-screen-insureds-coverages',
        image: require('../images/EN_UL_insureds-coverages.jpg'),
        infos: [
          {
            buttonPosition: [60, 11.3, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [1.3, 13.8, 56.4, 4.3],
            content: "You can select the type of insurance (individual or joint) for the scenario to ensure the illustration is consistent with the client’s needs.",
            modals: []
          },
          {
            buttonPosition: ['auto', 20.1, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.7, 23.6, 15.3, 4.5],
            content: "Click on the pencil to enter the insured’s full name.",
            modals: [
              {
                code: 'ul_insureds-coverages_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_insureds-coverages_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [102, 15.6, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [76.6, 18.3, 18.3, 3.7],
            content: "This clickable link allows you to show the impact of preferential status of one of the insureds.",
            modals: [
              {
                code: 'ul_insureds-coverages_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_insureds-coverages_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [102, 33.2, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [84.4, 36.5, 12.1, 3.9],
            content: "This clickable link allows you to add an extra premium on a coverage for an insured.",
            modals: [
              {
                code: 'ul_insureds-coverages_modal4',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_insureds-coverages_modal4.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [64, 34.9, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [1.9, 41.8, 52.6, 4.6],
            content: "Select the death benefit Face amount + fun with wealth maximizer option to optimize your client’s investments while keeping insurance cost as low as possible. Please refer to the Product Guide for more information.Only applicable with a YRT Product.",
            modals: []
          },
          {
            buttonPosition: ['auto', 42, 101],
            popupPosition: ['top', 'left'],
            pointerPosition: [2.4, 47.3, 95.5, 10.4],
            content: "You can change the scenario’s basic coverage. This section presents the additional options available based on the basic coverage selected.",
            modals: []
          },
          {
            buttonPosition: ['auto', 54, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.6, 52.1, 4.4, 5.6],
            content: "Click the document icon to access the <i>Product Guide</i>.",
            modals: []
          },
          {
            buttonPosition: [27, 58.4, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [1.8, 58.2, 23, 4],
            content: "Click on <i>Add a coverage/rider</i> to add additional coverage.",
            modals: [
              {
                code: 'ul_insureds-coverages_modal6',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_insureds-coverages_modal6.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [71, 58.4, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [61.4, 47.4, 30.8, 10.4],
            content: "Click on <i>Premium</i> to determine the face amount based on a given desired premium corresponding to the client's budget. You can enter the desired premium amount and the face amount will be automatically displayed. You can also indicate the face amount that your client wishes to insure by clicking the <i>Amount</i> button and it will determine the corresponding premium. You can illustrate insurance coverage that exceeds the limits of certain products, up to $90M.",
            modals: []
          },
          {
            buttonPosition: [102, 72.2, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [1.4, 69.4, 97.8, 30.3],
            content: "You can add an additional applicant or replace the applicant with a company. Click on the pencil to change the applicant, as needed.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: 'Coverages (General information, Premium deposit, Investments)',
        code: 'ul-ins-screen-coverage-info',
        image: require('../images/EN_UL_coverages-info.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 5, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 8, 93.7, 4],
            content: "Select the applicant’s province of residence.",
            modals: []
          },
          {
            buttonPosition: [105.6, 11.4, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [2.5, 13.4, 65.5, 4],
            content: "The tax rate for the province selected is shown by default. It can be changed. Click on <i>Other rates</i> to see the different types of rates and to manage the rates applicable to companies.",
            modals: [
              {
                code: 'ul_coverages-info_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_coverages-info_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 15.7, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 17.9, 76.4, 3.7],
            content: "Click on <i>Modify</i> to change the policy’s effective date. To learn more about the effective date, click on <i>Modify</i>, then click on the question mark in the upper right-hand corner.",
            modals: [
              {
                code: 'ul_coverages-info_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_coverages-info_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 28.1, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 30.3, 95.4, 4.2],
            content: "Choose the premium payment frequency. This selection will affect the amounts shown in the summary.",
            modals: []
          },
          {
            buttonPosition: [105.6, 37, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [2.5, 34.6, 95.4, 17.3],
            content: "Select the type of premium and maximize the premium, if desired, based on the client’s objectives.",
            modals: []
          },
          {
            buttonPosition: ['auto', 57.7, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 59.4, 45.8, 5.1],
            content: "You can change the compound interest rate based on the return you want to illustrate.",
            modals: []
          },
          {
            buttonPosition: ['auto', 78.8, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [4.4, 81, 75.7, 4.5],
            content: "Click on the respective links to manage lump-sum deposits and withdrawals related to the illustrated scenario. These amounts will be reflected in the results table.",
            modals: [
              {
                code: 'ul_coverages-info_modal7',
                content: '<div class="ui container" style="display: flex;flex-flow: row wrap;justify-content: space-around;"><img src="' + require('../images/EN_UL_coverages-info_modal7-1.jpg') + '" style="max-width: 90%"><img src="' + require('../images/EN_UL_coverages-info_modal7-2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
        ],
        modals: []
      },
      {
        title: "Investor Profile",
        code: 'ul-ins-screen-investor-profile',
        image: require('../images/EN_UL_investor.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 15, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 18.8, 14, 4.1],
            content: "This section presents the name of all applicants, whether they are an insured, an individual or a company.",
            modals: []
          },
          {
            buttonPosition: ['auto', 53.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 22.9, 19.6, 76.8],
            content: "This section shows the progress of the investor profile questionnaire.",
            modals: []
          },
          {
            buttonPosition: [72.6, 16.7, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [20.5, 22.9, 57.9, 76.8],
            content: "Complete this interactive questionnaire with your client to determine the investor profile. Once all questions have been answered, the result will be shown in the form of a graph to easily understand the client’s portrait.",
            modals: [
              {
                code: 'ul_investor_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_investor_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
        ],
        modals: []
      },
      {
        title: "Investments",
        code: 'ul-ins-screen-investments',
        image: require('../images/EN_UL_investments.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 36, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 38.5, 17.7, 4.5],
            content: "This button allows you to access the list of available investment accounts.",
            modals: [
              {
                code: 'ul_investments_modal1',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_investments_modal1.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [37.4, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [43.4, 23.2, 11.3, 4],
            content: "Check this box if you want the automatic deduction instructions (DDA) to be the same as the automatic investment instructions (AII).",
            modals: []
          },
          {
            buttonPosition: [51.1, 30.7, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [37.2, 33.1, 12.5, 3.6],
            content: "Indicate the desired percentage in the boxes to identify the composition of the DDA/AII.",
            modals: []
          },
          {
            buttonPosition: [71.1, 14.9, 'auto'],
            popupPosition: ['top', 'center'],
            pointerPosition: [66.9, 23.8, 6.1, 3.6],
            content: "Click on <i>Personalize</i> to make a projection by customizing the anticipated interest rate for the investment accounts of the accumulation funds individually on an annual basis or over a number of years adapted to the insured's situation.",
            modals: [
              {
                code: 'ul_investments_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_investments_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          }
        ],
        modals: []
      },
      {
        title: "Concepts",
        code: 'ul-ins-screen-concepts',
        image: require('../images/EN_UL_concepts.jpg'),
        infos: [
          {
            buttonPosition: [29.5, 21.5, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.7, 22.9, 27.1, 4.9],
            content: "The drop-down list allows you to select a concept to present.",
            modals: []
          },
          {
            buttonPosition: [-6.6, 29.5, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.5, 29.2, 54, 35.8],
            content: "You can change various settings to be applied to the concept.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Results",
        code: 'ul-ins-screen-results',
        image: require('../images/EN_UL_results.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 20, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 22.3, 22.2, 3.9],
            content: "The drop-down list also allows you to select the type of table to present.",
            modals: []
          },
          {
            buttonPosition: [34, 20.2, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [24, 22.3, 9.2, 3.9],
            content: "Click on this link to see the list of insured scenarios.",
            modals: [
              {
                code: 'ul_results_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_results_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [57.9, 17.3, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [64.1, 18.6, 14.8, 7.2],
            content: "Click on this button to export the results table into an Excel spreadsheet.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Reports",
        code: 'ul-ins-screen-reports',
        image: require('../images/EN_UL_reports.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 35, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 38, 49.6, 43],
            content: "Select the information you want to include in the report.",
            modals: []
          },
          {
            buttonPosition: [66, 81, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [50.6, 83.5, 14.4, 5.5],
            content: "Add the advisor's name to personalize the report.",
            modals: [
              {
                code: 'ul_reports_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_reports_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [45, 30, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [50.6, 31.7, 14, 5.5],
            content: "Select the language in which you want to generate the report.",
            modals: []
          },
          {
            buttonPosition: [58.1, 18, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [63.5, 18.5, 15.8, 9],
            content: "Click on this button to generate the personalized report in PDF format.",
            modals: []
          },
        ],
        modals: []
      }
    ]
  },
  {  // Traditional insurance
    productName: "Traditional insurance",
    productCode: 'ti-ins',
    slides: [
      {
        title: 'Launching EVO',
        code: 'ti-ins-lancement',
        image: require('../images/EN_launch.jpg'),
        infos: [
          {
            buttonPosition: [86, 24.5, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [92.3, 26.7, 7.3, 4.7],
            content: "Click on <i>Launch</i> to access EVO.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Home Page',
        code: 'ti-ins-home',
        image: require('../images/EN_TI_home.jpg'),
        infos: [
          {
            buttonPosition: [6.1, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.9, 29.2, 12.6, 6.5],
            content: "Check the <i>New Features</i> section for the latest updates to the EVO platform; tool enhancements, additional features and new products will be presented in detail in this section.",
            modals: [
              {
                code: 'ti_home_modal1',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_home_modal1.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [23.5, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.4, 36.7, 97.3, 63],
            content: "<i>Create an illustration</i> allows you to access the product family to be illustrated. Once the family has been selected, you can select a basic coverage in the middle of the screen.",
            modals: []
          },
          {
            buttonPosition: [39, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [37.3, 29.2, 8, 6.5],
            content: "<i>My files</i> allows you to consult and make changes to saved illustrations, including those created via the Interface Suite.",
            modals: [
              {
                code: 'ti_home_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_home_modal2.jpg') + '" style="max-width: 90%"></div><br>You can search for an existing sale by entering the name of the file, contractor or insured in the search bar. Note that this feature also applies to ongoing or completed sales.'
              }
            ]
          },
          {
            buttonPosition: [70.9, 18.5, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [62.3, 29.1, 22.1, 6.7],
            content: "Click on <i>Critical illness premium comparison tool</i> to view and compare critical illness insurance policy amounts and premiums on the same screen. It will also be available during the illustration in the critical illness insurance product.",
            modals: [
              {
                code: 'ti_home_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/comparison_modal.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [88.9, 18.5, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [84.4, 29.1, 14.1, 6.7],
            content: "<i>Make an e-change</i> allows you to request a change to an in-force policy: client information, addition of coverage, riders, etc.",
            modals: []
          },
          {
            buttonPosition: [84.6, 36.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [85.5, 30.1, 2.8, 4.6],
            content: "The padlock indicates that a connection is required to access the section.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'General Interface',
        code: 'ti-ins-general-interface',
        image: require('../images/EN_TI_general-interface.jpg'),
        infos: [
          {
            buttonPosition: ['auto', -1.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [-0.6, -1.2, 101.3, 7.4],
            content: "This menu allows you to: <ul>" +
              "<li><img src='" + require('../images/icon-tool.jpg') + "'> Transfer the file to a third party</li>" +
              "<li><img src='" + require('../images/label-connection_EN.jpg') + "' width='73'> Establish a secure connection</li>" +
              "<li><img src='" + require('../images/icon-save.jpg') + "'> Save the illustration and activate the automatic save function</li>" +
              "<li><img src='" + require('../images/icon-suitcase.jpg') + "'> Requirements – Life Insurance / Critical Illness Insurance</li>" +
              "<li><img src='" + require('../images/icon-home.jpg') + "'> Go back to the product family home page</li>" +
              "<li><img src='" + require('../images/icon-settings.jpg') + "'> Customize your profile and default settings</li>" +
              "<li><img src='" + require('../images/icon-help.jpg') + "'> Get information about the software</li>" + "</ul>",
            modals: []
          },
          {
            buttonPosition: ['auto', 8.6, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 5.8, 43.7, 5],
            content: "This section allows you to create a new scenario or duplicate one to illustrate alternatives for your client or family members, up to a maximum of five scenarios. Scenarios can also be reset.",
            modals: []
          },
          {
            buttonPosition: [34.5, 9.9, 'auto'],
            popupPosition: ['right', 'center'],
            pointerPosition: [2, 11.6, 30.9, 4.8],
            content: "<b><u>Coverages</u>: </b>allows you to show the type of coverage selected, identify the insureds and applicants, select additional coverages and riders, and simulate a premium based on projected deposits and withdrawals.<br><br>" +
              "<b><u>Results</u>: </b>allows you to consult the projection results grid for the current scenario.<br><br>" +
              "<b><u>Reports</u>: </b>allows you to generate and print the illustration report.",
            modals: []
          },
          {
            buttonPosition: ['auto', 45, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 16.3, 79.1, 82.6],
            content: "This section allows you to enter the illustration information quickly in order to quickly get a premium.",
            modals: []
          },
          {
            buttonPosition: [74.1, 7, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [79.2, 16.3, 20.5, 83.3],
            content: "<b><u>Contract</u>: </b>shows the premium paid for your client’s policy as well as the reference and maximum premium.<br><br>" +
              "<b><u>Coverage details</u>: </b>shows all coverages for all insureds in the current scenario.<br><br>" +
              "<b><u>Go to the e-application</u>: </b>if one of the checkmarks is grey, you must add the missing information before you can move on to the application.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Coverages (Insureds and Coverages)',
        code: 'ti-ins-screen-insureds-coverages',
        image: require('../images/EN_TI_insureds-coverages.jpg'),
        infos: [
          {
            buttonPosition: [62, 9, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [1.3, 11.9, 56.7, 4],
            content: "You can select the type of insurance (individual or joint) for the scenario to ensure the illustration is consistent with the client’s needs.",
            modals: []
          },
          {
            buttonPosition: [102, 13, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [76.8, 16.2, 18.3, 3.5],
            content: "This clickable link allows you to show the impact of preferential status of one of the insureds.",
            modals: [
              {
                code: 'ti_insureds-coverages_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_insureds-coverages_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [39, 16.6, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [19, 20.8, 18, 4.3],
            content: "It is possible to add additional insureds: You must choose the basic coverage for each additional insured.",
            modals: []
          },
          {
            buttonPosition: ['auto', 24, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [3.1, 26.7, 15.3, 3.8],
            content: "Click on the pencil to enter the insured’s full name.",
            modals: [
              {
                code: 'ti_insureds-coverages_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_insureds-coverages_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [102, 35, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [85.8, 37.5, 10, 3.9],
            content: "This clickable link allows you to add an extra premium on a coverage for an insured.",
            modals: [
              {
                code: 'ti_insureds-coverages_modal4',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_insureds-coverages_modal4.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 38.1, 101],
            popupPosition: ['top', 'left'],
            pointerPosition: [2.9, 42.6, 95, 9.6],
            content: "You can change the scenario’s basic coverage. This section presents the additional options available based on the basic coverage selected.",
            modals: []
          },
          {
            buttonPosition: ['auto', 48.1, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [3.1, 46.8, 4.4, 5.3],
            content: "Click the document icon to access the <i>Product Guide</i>.",
            modals: []
          },
          {
            buttonPosition: [28.6, 58.5, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [3, 57.8, 22.7, 3.3],
            content: "Click on <i>Add a coverage/rider</i> to add additional coverage.",
            modals: [
              {
                code: 'ti_insureds-coverages_modal6',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_insureds-coverages_modal6.jpg') + '" style="max-width: 90%"></div><br>Ce panneau permet de faire les choix de protections supplémentaires selon les besoins de votre client.'
              }
            ]
          },
          {
            buttonPosition: [49, 42.2, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [2.7, 52.4, 47.2, 4.8],
            content: "Enter the projection duration desired by the contractor according to their needs for each temporary protection selected. Note that the minimum and maximum values allowed are indicated and that the default value will be the maximum duration available for the protection.",
            modals: []
          },
          {
            buttonPosition: [71, 53.1, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [61.5, 42.8, 30.8, 9.5],
            content: "Click on <i>Premium</i> to determine the face amount based on a given desired premium corresponding to the client's budget. You can enter the desired premium amount and the face amount will be automatically displayed. You can also indicate the face amount that your client wishes to insure by clicking the <i>Amount</i> button and it will determine the corresponding premium. You can illustrate insurance coverage that exceeds the limits of certain products, up to $90M.",
            modals: []
          },
          {
            buttonPosition: [102, 74.2, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [1.5, 73.4, 97.2, 26.2],
            content: "You can add an additional applicant or replace the applicant with a company. Click on the pencil to change the applicant, as needed.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Coverages (General information, Premium deposit)',
        code: 'ti-ins-screen-coverage-info',
        image: require('../images/EN_TI_coverages-info.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 9, 103],
            popupPosition: ['top', 'left'],
            pointerPosition: [2.5, 13.8, 83.1, 7.2],
            content: "Select the applicant’s province of residence.",
            modals: []
          },
          {
            buttonPosition: [104, 20.4, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [2.5, 23.8, 65.7, 7.2],
            content: "The tax rate for the selected province is displayed by default and can be changed. Click on <i>Other rates</i> to see the different types of rates and manage corporate rates.",
            modals: [
              {
                code: 'ti_coverages-info_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_coverages-info_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 28, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 32.7, 74.4, 5.7],
            content: "Click on <i>Modify</i> to change the policy’s effective date. To learn more about the effective date, click on <i>Modify</i>, then click on the question mark in the upper right-hand corner.",
            modals: [
              {
                code: 'ti_coverages-info_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_coverages-info_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 49.6, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 52.9, 93.4, 8.9],
            content: "Choose the premium payment frequency. This selection will affect the amounts shown in the summary.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Results",
        code: 'ti-ins-screen-results',
        image: require('../images/EN_TI_results.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 18, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 20, 18.1, 3.91],
            content: "The drop-down list also allows you to select the type of table to present.",
            modals: []
          },
          {
            buttonPosition: [29.4, 18, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [20, 20, 7.4, 3.91],
            content: "Click on this link to see the list of insured scenarios.",
            modals: [
              {
                code: 'ti_results_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_results_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [58.1, 16.1, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [64.1, 17, 14.8, 6.4],
            content: "Click on this button to export the results table into an Excel spreadsheet.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Reports",
        code: 'ti-ins-screen-reports',
        image: require('../images/EN_TI_reports.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 35, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 38, 49.6, 22],
            content: "Select the information you want to include in the report.",
            modals: []
          },
          {
            buttonPosition: [66, 81, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [50.6, 83.5, 14.4, 5.5],
            content: "Add the advisor's name to personalize the report.",
            modals: [
              {
                code: 'ti_reports_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_reports_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [45, 30, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [50.6, 31.8, 14, 5.5],
            content: "Select the language in which you want to generate the report.",
            modals: []
          },
          {
            buttonPosition: [58.1, 18, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [63.5, 18.5, 15.8, 9],
            content: "Click on this button to generate the personalized report in PDF format.",
            modals: []
          },
        ],
        modals: []
      }
    ]
  },
  {  // Critical Illness insurance
    productName: "Critical Illness insurance",
    productCode: 'ci-ins',
    slides: [
      {
        title: 'Launching EVO',
        code: 'ci-ins-lancement',
        image: require('../images/EN_launch.jpg'),
        infos: [
          {
            buttonPosition: [86, 24.5, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [92.3, 26.7, 7.3, 4.7],
            content: "Click on <i>Launch</i> to access EVO.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Home Page',
        code: 'ci-ins-home',
        image: require('../images/EN_CI_home.jpg'),
        infos: [
          {
            buttonPosition: [6.1, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.9, 29.2, 12.6, 6.5],
            content: "Check the <i>New Features</i> section for the latest updates to the EVO platform; tool enhancements, additional features and new products will be presented in detail in this section.",
            modals: [
              {
                code: 'ci_home_modal1',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_CI_home_modal1.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [23.5, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.4, 36.7, 97.3, 63],
            content: "<i>Create an illustration</i> allows you to access the product family to be illustrated. Once the family has been selected, you can select a basic coverage in the middle of the screen.",
            modals: []
          },
          {
            buttonPosition: [39, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [37.3, 29.2, 8, 6.5],
            content: "<i>My files</i> allows you to consult and make changes to saved illustrations, including those created via the Interface Suite.",
            modals: [
              {
                code: 'ci_home_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_CI_home_modal2.jpg') + '" style="max-width: 90%"></div><br>You can search for an existing sale by entering the name of the file, contractor or insured in the search bar. Note that this feature also applies to ongoing or completed sales.'
              }
            ]
          },
          {
            buttonPosition: [70.9, 18.5, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [62.3, 29.1, 22.1, 6.7],
            content: "Click on <i>Critical illness premium comparison tool</i> to view and compare critical illness insurance policy amounts and premiums on the same screen. It will also be available during the illustration in the critical illness insurance product. Proceed to the next screen to see the details of this feature.",
            modals: []
          },
          {
            buttonPosition: [88.9, 18.5, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [84.4, 29.1, 14.1, 6.7],
            content: "<i>Make an e-change</i> allows you to request a change to an in-force policy: client information, addition of coverage, riders, etc.",
            modals: []
          },
          {
            buttonPosition: [84.6, 36.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [85.5, 30.1, 2.8, 4.6],
            content: "The padlock indicates that a connection is required to access the section.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Premium comparison tool',
        code: 'ci-ins-comparison-tool',
        image: require('../images/EN_CI_comparison.jpg'),
        infos: [
          {
            buttonPosition: [-3.3, 36.5, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [4.8, 33.7, 22.7, 11.9],
            content: "Enter the insured's information to obtain the basic and total premiums in the <i>Protection</i> section on the right",
            modals: []
          },
          {
            buttonPosition: [-3.3, 53.5, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [4.2, 51.2, 23.8, 13.3],
            content: "Click on the <i>Premium</i> button to determine the amount of insurance based on a given premium that fits the client's budget. You will be able to enter the premium amount and the insurance amount will be displayed automatically. You can also switch to the <i>Amount</i> button and then enter the amount of insurance to get the corresponding premium. You can also choose the frequency of premium payment.",
            modals: []
          },
          {
            buttonPosition: [-3.3, 71.5, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [4.2, 68.4, 23.8, 15.3],
            content: "Select one of the riders below according to the insured's needs.",
            modals: []
          },
          {
            buttonPosition: [85.2, 20.5, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [29.2, 33.6, 66.6, 53.6],
            content: "This section updates the basic, total premiums and insured amounts according to the choices made in the section on the left. Select the desired coverage to highlight it. ",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'General Interface',
        code: 'ci-ins-general-interface',
        image: require('../images/EN_CI_general-interface.jpg'),
        infos: [
          {
            buttonPosition: ['auto', -1.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [-0.6, -0.4, 101.3, 5.8],
            content: "This menu allows you to: <ul>" +
              "<li><img src='" + require('../images/icon-tool.jpg') + "'> Transfer the file to a third party</li>" +
              "<li><img src='" + require('../images/label-connection_EN.jpg') + "' width='73'> Establish a secure connection</li>" +
              "<li><img src='" + require('../images/icon-save.jpg') + "'> Save the illustration and activate the automatic save function</li>" +
              "<li><img src='" + require('../images/icon-suitcase.jpg') + "'> Requirements – Life Insurance / Critical Illness Insurance</li>" +
              "<li><img src='" + require('../images/icon-home.jpg') + "'> Go back to the product family home page</li>" +
              "<li><img src='" + require('../images/icon-settings.jpg') + "'> Customize your profile and default settings</li>" +
              "<li><img src='" + require('../images/icon-help.jpg') + "'> Get information about the software</li>" + "</ul>",
            modals: []
          },
          {
            buttonPosition: ['auto', 8.6, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 5.5, 43.7, 5],
            content: "This section allows you to create a new scenario or duplicate one to illustrate alternatives for your client or family members, up to a maximum of five scenarios. Scenarios can also be reset.",
            modals: []
          },
          {
            buttonPosition: [34.5, 9.9, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [2, 11.6, 30.9, 4.8],
            content: "<b><u>Coverages</u>: </b>allows you to show the type of coverage selected, identify the insureds and applicants, select additional coverages and riders, and simulate a premium based on projected deposits and withdrawals.<br><br>" +
              "<b><u>Results</u>: </b>allows you to consult the projection results grid for the current scenario.<br><br>" +
              "<b><u>Reports</u>: </b>allows you to generate and print the illustration report.",
            modals: []
          },
          {
            buttonPosition: ['auto', 45, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 16.3, 79.1, 83.2],
            content: "This section allows you to enter the illustration information quickly in order to quickly get a premium.",
            modals: []
          },
          {
            buttonPosition: [74.1, 7, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [79.2, 16.3, 20.5, 83.3],
            content: "<b><u>Contract</u>: </b>shows the premium paid for your client’s policy as well as the reference and maximum premium.<br><br>" +
              "<b><u>Coverage details</u>: </b>shows all coverages for all insureds in the current scenario.<br><br>" +
              "<b><u>Go to the e-application</u>: </b>if one of the checkmarks is grey, you must add the missing information before you can move on to the application.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Coverages (Insureds and Coverages)',
        code: 'ci-ins-screen-insureds-coverages',
        image: require('../images/EN_CI_insureds-coverages.jpg'),
        infos: [
          {
            buttonPosition: [31.5, 7, 'auto'],
            popupPosition: ['right', 'center'],
            pointerPosition: [1.3, 11.1, 29.3, 4.4],
            content: "You can view the type of insurance here, but it cannot be changed for this type of basic coverage in the contract.",
            modals: []
          },
          {
            buttonPosition: [41, 17.4, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [18.7, 19.8, 18.3, 3.5],
            content: "It is possible to add additional insureds: You must choose the basic coverage for each additional insured.",
            modals: []
          },
          {
            buttonPosition: ['auto', 21.8, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.8, 25, 15.3, 3.8],
            content: "Click on the pencil to enter the insured’s full name.",
            modals: [
              {
                code: 'ci_insureds-coverages_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_CI_insureds-coverages_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 34.9, 101],
            popupPosition: ['top', 'left'],
            pointerPosition: [2.5, 40.1, 95.5, 9],
            content: "You can change the scenario’s basic coverage. This section presents the additional options available based on the basic coverage selected.",
            modals: []
          },
          {
            buttonPosition: [49, 32.9, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [61.9, 35.3, 24.5, 3.9],
            content: "Click on <i>Premium</i> comparison tool to view and compare critical illness insurance policy amounts and premiums on the same screen. Among other things, you will be able to indicate the insured's information, the premium amount or the insurance amount for this coverage. Click <i>Apply</i> to add the coverage.",
            modals: [
              {
                code: 'ci_insureds-coverages_modal10',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_CI_insureds-coverages_modal10.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [102, 32.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [85.7, 35.3, 9.4, 3.9],
            content: "This clickable link allows you to add an extra premium on a coverage for an insured.",
            modals: [
              {
                code: 'ci_insureds-coverages_modal4',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_CI_insureds-coverages_modal4.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 44.9, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.8, 44.4, 4.6, 4.8],
            content: "Click the document icon to access the <i>Product Guide</i>.",
            modals: []
          },
          {
            buttonPosition: [29.6, 59.7, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [2.6, 60.1, 25.3, 3.3],
            content: "Click on <i>Add a coverage/rider</i> to add additional coverage.",
            modals: [
              {
                code: 'ci_insureds-coverages_modal7',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_CI_insureds-coverages_modal6.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [51, 50.2, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [2.7, 49.2, 47, 4.6],
            content: "Enter the projection duration desired by the contractor according to their needs for each temporary protection selected. Note that the minimum and maximum values allowed are indicated and that the default value will be the maximum duration available for the protection.",
            modals: []
          },
          {
            buttonPosition: [71, 49.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [61.5, 40.1, 30.9, 8.9],
            content: "Click on <i>Premium</i> to determine the face amount based on a given desired premium corresponding to the client's budget. You can enter the desired premium amount and the face amount will be automatically displayed. You can also indicate the face amount that your client wishes to insure by clicking the <i>Amount</i> button and it will determine the corresponding premium. You can illustrate insurance coverage that exceeds the limits of certain products, up to $90M.",
            modals: []
          },
          {
            buttonPosition: [102, 73.2, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [1.4, 73.7, 97.5, 25.4],
            content: "You can add an additional applicant or replace the applicant with a company. Click on the pencil to change the applicant, as needed.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: 'Coverages (General information, Premium deposit)',
        code: 'ci-ins-screen-coverage-info',
        image: require('../images/EN_CI_coverages-info.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 9, 103],
            popupPosition: ['top', 'left'],
            pointerPosition: [2.5, 13.8, 83.9, 7.5],
            content: "Select the applicant’s province of residence.",
            modals: []
          },
          {
            buttonPosition: [104, 20.4, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [2.5, 23.5, 65.9, 7.6],
            content: "The tax rate for the selected province is displayed by default and can be changed. Click on <i>Other rates</i> to see the different types of rates and manage corporate rates.",
            modals: [
              {
                code: 'ci_coverages-info_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_coverages-info_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 28, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 32.2, 74.4, 5.7],
            content: "Click on <i>Modify</i> to change the policy’s effective date. To learn more about the effective date, click on <i>Modify</i>, then click on the question mark in the upper right-hand corner.",
            modals: [
              {
                code: 'ci_coverages-info_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_CI_coverages-info_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 49.6, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 52.9, 93.4, 8.9],
            content: "Choose the premium payment frequency. This selection will affect the amounts shown in the summary.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Results",
        code: 'ci-ins-screen-results',
        image: require('../images/EN_CI_results.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 18, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 20, 18.1, 3.91],
            content: "The drop-down list also allows you to select the type of table to present.",
            modals: []
          },
          {
            buttonPosition: [29.4, 18, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [20, 20, 7.2, 3.91],
            content: "Click on this link to see the list of insured scenarios.",
            modals: [
              {
                code: 'ci_results_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_CI_results_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [58.1, 16.1, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [64.1, 17, 14.7, 6.4],
            content: "Click on this button to export the results table into an Excel spreadsheet.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Reports",
        code: 'ci-ins-screen-reports',
        image: require('../images/EN_CI_reports.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 35, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 38, 49.6, 26],
            content: "Select the information you want to include in the report.",
            modals: []
          },
          {
            buttonPosition: [66, 81, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [50.6, 83.5, 14.4, 5.5],
            content: "Add the advisor's name to personalize the report.",
            modals: [
              {
                code: 'ci_reports_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_CI_reports_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [45, 30, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [50.6, 31.8, 14, 5.5],
            content: "Select the language in which you want to generate the report.",
            modals: []
          },
          {
            buttonPosition: [58.1, 18, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [63.5, 18.5, 15.8, 9],
            content: "Click on this button to generate the personalized report in PDF format.",
            modals: []
          },
        ],
        modals: []
      }
    ]
  },
  {  // Participating Life insurance
    productName: "Participating Life insurance",
    productCode: 'pli-ins',
    slides: [
      {
        title: 'Launching EVO',
        code: 'pli-ins-lancement',
        image: require('../images/EN_launch.jpg'),
        infos: [
          {
            buttonPosition: [86, 24.5, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [92.3, 26.7, 7.3, 4.7],
            content: "Click on <i>Launch</i> to access EVO.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Home Page',
        code: 'pli-ins-home',
        image: require('../images/EN_PLI_home.jpg'),
        infos: [
          {
            buttonPosition: [5.5, 19.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.9, 28.2, 12.5, 6.5],
            content: "Check the <i>New Features</i> section for the latest updates to the EVO platform; tool enhancements, additional features and new products will be presented in detail in this section.",
            modals: [
              {
                code: 'pli_home_modal1',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_home_modal1.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [22.3, 19.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.4, 37.7, 97.3, 61],
            content: "<i>Create an illustration</i> allows you to access the product family to be illustrated. Once the family has been selected, you can select a basic coverage in the middle of the screen.",
            modals: []
          },
          {
            buttonPosition: [39, 19.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [37.5, 28.2, 7.8, 6.5],
            content: "<i>My files</i> allows you to consult and make changes to saved illustrations, including those created via the Interface Suite.",
            modals: [
              {
                code: 'pli_home_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_home_modal2.jpg') + '" style="max-width: 90%"></div><br>You can search for an existing sale by entering the name of the file, contractor or insured in the search bar. Note that this feature also applies to ongoing or completed sales.'
              }
            ]
          },
          {
            buttonPosition: [70.9, 17.5, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [62.9, 28.1, 21.4, 5.9],
            content: "Click on <i>Critical illness premium comparison tool</i> to view and compare critical illness insurance policy amounts and premiums on the same screen. It will also be available during the illustration in the critical illness insurance product.",
            modals: [
              {
                code: 'pli_home_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/comparison_modal.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [88.9, 17.5, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [84.8, 28.1, 13.8, 5.9],
            content: "<i>Make an e-change</i> allows you to request a change to an in-force policy: client information, addition of coverage, riders, etc.",
            modals: []
          },
          {
            buttonPosition: [84.6, 37.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [85.3, 28.5, 3.2, 5.1],
            content: "The padlock indicates that a connection is required to access the section.",
            modals: []
          },
          {
            buttonPosition: [-6.6, 76, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.6, 77.1, 23.9, 20],
            content: "Select the group <i>Concepts</i> to illustrate certain eligible products and demonstrate how they can help your clients achieve their financial goals and meet their insurance needs.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'General Interface',
        code: 'pli-ins-general-interface',
        image: require('../images/EN_PLI_general-interface.jpg'),
        infos: [
          {
            buttonPosition: ['auto', -1.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [-0.6, -0.8, 101.3, 6.7],
            content: "This menu allows you to: <ul>" +
              "<li><img src='" + require('../images/icon-tool.jpg') + "'> Transfer the file to a third party</li>" +
              "<li><img src='" + require('../images/label-connection_EN.jpg') + "' width='73'> Establish a secure connection</li>" +
              "<li><img src='" + require('../images/icon-save.jpg') + "'> Save the illustration and activate the automatic save function</li>" +
              "<li><img src='" + require('../images/icon-suitcase.jpg') + "'> Requirements – Life Insurance / Critical Illness Insurance</li>" +
              "<li><img src='" + require('../images/icon-home.jpg') + "'> Go back to the product family home page</li>" +
              "<li><img src='" + require('../images/icon-settings.jpg') + "'> Customize your profile and default settings</li>" +
              "<li><img src='" + require('../images/icon-help.jpg') + "'> Get information about the software</li>" + "</ul>",
            modals: []
          },
          {
            buttonPosition: [51.1, 6.6, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [0.3, 5.5, 43.9, 5.6],
            content: "This section allows you to create a new scenario or duplicate one to illustrate alternatives for your client or family members, up to a maximum of five scenarios. Scenarios can also be reset.",
            modals: []
          },
          {
            buttonPosition: [44, 12.9, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [2, 12, 40, 4.8],
            content: "<b><u>Coverages</u>: </b>allows you to show the type of coverage selected, identify the insureds and applicants, select additional coverages and riders, and simulate a premium based on projected deposits and withdrawals.<br><br>" +
              "<b><u>Concepts</u>: </b>allows you to activate and configure a sales concept for the illustration in progress or deactivate it.<br><br>" +
              "<b><u>Results</u>: </b>allows you to consult the projection results grid for the current scenario.<br><br>" +
              "<b><u>Reports</u>: </b>allows you to generate and print the illustration report.",
            modals: []
          },
          {
            buttonPosition: ['auto', 45, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.6, 17.5, 78.2, 82],
            content: "This section allows you to enter the illustration information quickly in order to quickly get a premium.",
            modals: []
          },
          {
            buttonPosition: [74.1, 90, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [79.2, 17.5, 20.2, 82],
            content: "<b><u>Contract</u>: </b>shows the premium paid for your client’s policy as well as the reference and maximum premium.<br><br>" +
              "<b><u>Coverage details</u>: </b>shows all coverages for all insureds in the current scenario.<br><br>" +
              "<b><u>Go to the e-application</u>: </b>if one of the checkmarks is grey, you must add the missing information before you can move on to the application.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Coverages (Insureds and Coverages)',
        code: 'pli-ins-screen-insureds-coverages',
        image: require('../images/EN_PLI_insureds-coverages.jpg'),
        infos: [
          {
            buttonPosition: [59.7, 10.7, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [1.4, 12.9, 55.8, 4.6],
            content: "You can view the type of insurance here, but it cannot be changed for this type of basic coverage in the contract.",
            modals: []
          },
          {
            buttonPosition: [102, 15, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [76.3, 18.2, 18.3, 3.5],
            content: "This clickable link allows you to show the impact of preferential status of one of the insureds.",
            modals: [
              {
                code: 'pli_insureds-coverages_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_insureds-coverages_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 23, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.3, 22.9, 14.3, 4.7],
            content: "Click on the pencil to enter the insured’s full name.",
            modals: [
              {
                code: 'pli_insureds-coverages_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_PLI_insureds-coverages_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [102, 33, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [85.1, 35.7, 10, 3.9],
            content: "This clickable link allows you to add an extra premium on a coverage for an insured.",
            modals: [
              {
                code: 'pli_insureds-coverages_modal4',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_PLI_insureds-coverages_modal4.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [47, 35, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [1.7, 41.2, 42.4, 4.2],
            content: "Select the dividend allocation option that best suits your client. Dividends, which are non-guaranteed, are calculated annually and paid on the policy anniversary date.",
            modals: []
          },
          {
            buttonPosition: ['auto', 41, 101],
            popupPosition: ['top', 'left'],
            pointerPosition: [2.3, 46.7, 95.3, 10],
            content: "You can change the scenario’s basic coverage. This section presents the additional options available based on the basic coverage selected.",
            modals: []
          },
          {
            buttonPosition: ['auto', 53, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 51.5, 4.1, 5.3],
            content: "Click the document icon to access the <i>Product Guide</i>.",
            modals: []
          },
          {
            buttonPosition: [28.6, 57.7, 'auto'],
            popupPosition: ['right', 'center'],
            pointerPosition: [1.4, 57.2, 22.6, 4.5],
            content: "Click on <i>Add a coverage/rider</i> to add additional coverage.",
            modals: [
              {
                code: 'pli_insureds-coverages_modal6',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_insureds-coverages_modal6.jpg') + '" style="max-width: 90%"></div><br>Ce panneau permet de faire les choix de protections supplémentaires selon les besoins de votre client.'
              }
            ]
          },
          {
            buttonPosition: [102, 46, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [61, 46.7, 31, 10],
            content: "Click on <i>Premium</i> to determine the face amount based on a given desired premium corresponding to the client's budget. You can enter the desired premium amount and the face amount will be automatically displayed. You can also indicate the face amount that your client wishes to insure by clicking the <i>Amount</i> button and it will determine the corresponding premium. You can illustrate insurance coverage that exceeds the limits of certain products, up to $90M.",
            modals: []
          },
          {
            buttonPosition: [102, 71.2, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [1.3, 68.5, 97.4, 30],
            content: "You can add an additional applicant or replace the applicant with a company. Click on the pencil to change the applicant, as needed.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: 'Coverages (General information, Premium deposit, Change to dividend allocation)',
        code: 'pli-ins-screen-coverage-info',
        image: require('../images/EN_PLI_coverages-info.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 9, 103],
            popupPosition: ['top', 'left'],
            pointerPosition: [3.1, 10.2, 82.8, 5.7],
            content: "Select the applicant’s province of residence.",
            modals: []
          },
          {
            buttonPosition: [104, 17, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [3.1, 18, 65.7, 5.3],
            content: "The tax rate for the selected province is displayed by default and can be changed. Click on <i>Other rates</i> to see the different types of rates and manage corporate rates.",
            modals: [
              {
                code: 'pli_coverages-info_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_coverages-info_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 24.3, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [3.1, 23.2, 81.5, 7.5],
            content: "Click on <i>Modify</i> to change the policy’s effective date. To learn more about the effective date, click on <i>Modify</i>, then click on the question mark in the upper right-hand corner.",
            modals: [
              {
                code: 'pli_coverages-info_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_PLI_coverages-info_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 41.9, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [3.1, 39.7, 92, 8.5],
            content: "Choose the premium payment frequency. This selection will affect the amounts shown in the summary.",
            modals: []
          },
          {
            buttonPosition: [72.6, 53.7, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [3.1, 53.4, 68.4, 7.2],
            content: "Check the <i>Additional deposit option</i> box if your client wishes to make a contribution that allows them to buy additional paid-up insurance. The additional paid-up insurance results in both increased coverage and an increased policy cash value.",
            modals: []
          },
          {
            buttonPosition: ['auto', 65.6, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [3.1, 65, 40.4, 7.2],
            content: "Check the <i>Premium offset</i> box to target a date after which clients can stop paying their premium thanks to annual contributions. There is also another feature that indicates to clients the earliest time at which premium offset is available. Please refer to the <i>Product Guide</i> for additional information.",
            modals: []
          },
          {
            buttonPosition: ['auto', 89.1, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [3.1, 86.8, 90, 7.2],
            content: "Check the <i>Paid-up additions to Payable in cash option</i> box in order to forecast a moment when the client will receive their annual dividends in cash. You can then choose to illustrate the earliest this option is available or a subsequent year of your choosing.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: "Concepts",
        code: 'pli-ins-screen-concepts',
        image: require('../images/EN_PLI_concepts.jpg'),
        infos: [
          {
            buttonPosition: [29.5, 21.1, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.7, 21.8, 27.1, 5.0],
            content: "The drop-down list allows you to select a concept to present.",
            modals: []
          },
          {
            buttonPosition: [-6.6, 29.1, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.5, 28.1, 54, 35.8],
            content: "You can change various settings to be applied to the concept.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Results",
        code: 'pli-ins-screen-results',
        image: require('../images/EN_PLI_results.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 20.5, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.5, 21.4, 22.1, 3.6],
            content: "The drop-down list also allows you to select the type of table to present.",
            modals: []
          },
          {
            buttonPosition: [35.4, 20.5, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [23.8, 21.4, 7, 3.7],
            content: "Click on this link to see the list of insured scenarios.",
            modals: [
              {
                code: 'par_results_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_TI_results_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [57.9, 17.9, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [64.1, 17.3, 14.8, 7],
            content: "Click on this button to export the results table into an Excel spreadsheet.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Reports",
        code: 'pli-ins-screen-reports',
        image: require('../images/EN_PLI_reports.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 45, 100],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.7, 34, 49.6, 38.5],
            content: "Select the information you want to include in the report.",
            modals: []
          },
          {
            buttonPosition: [66, 86.2, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [50.6, 90, 12.4, 3.7],
            content: "Add the advisor's name to personalize the report.",
            modals: [
              {
                code: 'par_reports_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/EN_UL_reports_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [45, 27, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [50.6, 29.1, 14, 3.7],
            content: "Select the language in which you want to generate the report.",
            modals: []
          },
          {
            buttonPosition: [58.1, 15.5, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [63.6, 16.8, 15.6, 7.6],
            content: "Click on this button to generate the personalized report in PDF format.",
            modals: []
          },
        ],
        modals: []
      }
    ]
  }
];
export { texts, demoTexts };
